import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { fontRoboto, fontRobotoCondensed } from "@product/scmp-sdk";

export const Container = styled.div`
  position: relative;

  display: block;

  min-block-size: 72px;
  margin-inline-start: 22px;
  padding-inline-start: 22px;

  cursor: pointer;

  border-inline-start: 1px dashed #979797;
`;

export const Dot = styled.div`
  position: absolute;
  inset-block-start: 3px;

  inline-size: 7px;
  block-size: 7px;
  margin-inline-start: -26px;

  border-radius: 50%;

  background-color: #ffca05;
`;

export const Time = styled.div`
  margin-block-end: 2px;

  color: #000000;
  font-size: 12px;
  font-family: ${fontRobotoCondensed};
  line-height: 14px;
`;

type Props = {
  $isHighlighted: boolean;
};

export const Title = styled.div<Props>`
  padding-block-end: 20px;

  &:hover {
    span {
      color: #2c4692;
    }
  }

  span {
    color: #999999;
    font-size: 14px;
    font-family: ${fontRoboto};
    line-height: 18px;

    background-color: transparent;

    ${props =>
      props.$isHighlighted
        ? css`
            color: #000000;

            background-color: #ffca05;
          `
        : null};
  }
`;
